import React, { CSSProperties, FC, ReactNode } from 'react';
import styles from './IconButton.module.css';
import clsx from 'clsx';

export interface IconButtonProps {
  hover?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
  ariaLabel?: string;
  s?: CSSProperties;
  children: ReactNode;
  'data-test'?: string | null;
}

const IconButton: FC<IconButtonProps> = ({
  hover = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  children,
  onBlur,
  ariaLabel = 'clickable icon',
  'data-test': dataTest = null,
}) => {
  const classes = clsx({
    [styles.iconButton]: true,
    [styles.iconButtonHover]: hover,
  });

  return (
    <button
      className={classes}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onClick={onClick}
      onBlur={onBlur}
      aria-label={ariaLabel}
      data-test={dataTest}
    >
      {children}
    </button>
  );
};

export default IconButton;
